module.exports = __webpack_public_path__ + "img/arrowRightRed.3183a9d.png";